export default {"src":"/_next/static/media/account.bea2daa2.svg","height":20,"width":20};